import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { TableModule, TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { UserService } from '@services/user.service';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { PlaceholderTable } from '@components/placeholders/table/table.component';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { DrawerModule } from 'primeng/drawer';
import { SelectModule } from 'primeng/select';
import { IftaLabelModule } from 'primeng/iftalabel';
import { ChipModule } from 'primeng/chip';

@Component({
  selector: 'app-user-list',
  imports: [
    CommonModule,
    FormsModule,
    BackboneComponent,
    BreadcrumbComponent,
    TableModule,
    TagModule,
    InputTextModule,
    ButtonModule,
    RouterModule,
    IconFieldModule,
    InputIconModule,
    PlaceholderTable,
    InputGroup,
    InputGroupAddonModule,
    DrawerModule,
    IftaLabelModule,
    SelectModule,
    ChipModule,
  ],
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
})
export class UserListPage {
  private userService = inject(UserService);

  public isLoading = false;
  public searchValue: string | undefined;

  public breadcrumbUsers: any[] = [];
  public users: any[] = [];
  public roles: any = [];

  async ngOnInit() {
    this.userService.roles().then((response: any) => (this.roles = response));

    this.getUsers();
  }

  getUsers = async () => {
    this.isLoading = true;

    this.breadcrumbUsers = [];

    await this.userService.getList().then((response) => (this.users = response));

    this.isLoading = false;
  };

  getParentUser = async (userId: number, nickname: string, index: number | null = null) => {
    this.isLoading = true;

    if (index !== null) {
      this.breadcrumbUsers = this.breadcrumbUsers.slice(0, index + 1);
    } else {
      this.breadcrumbUsers.push({ nickname: nickname, userId: userId });
    }

    await this.userService.getParentUserList(userId).then((response) => (this.users = response));

    this.isLoading = false;
  };

  findRole = (id: number) => this.roles.find((role: any) => role.userRoleId === id);

  onRowExpand(event: TableRowExpandEvent) {}

  onRowCollapse(event: TableRowCollapseEvent) {}
}
